import { render, staticRenderFns } from "./ErrorTp.vue?vue&type=template&id=4736b2cd&scoped=true"
import script from "./ErrorTp.vue?vue&type=script&lang=ts"
export * from "./ErrorTp.vue?vue&type=script&lang=ts"
import style0 from "./ErrorTp.vue?vue&type=style&index=0&id=4736b2cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736b2cd",
  null
  
)

export default component.exports